export default "__VITE_ASSET__CBxX81kb__"